import { Skeleton } from '@mui/material';
import { Navigate, useParams } from 'react-router';

import { useProjectPermissions } from '../../hooks/useProjectPermissions';
import { ProjectAccessDenied } from '../ProjectAccessDenied/ProjectAccessDenied';

export const ProjectIndexRedirect = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { getDefaultTab, isLoading } = useProjectPermissions(projectId!);

  if (isLoading) {
    return <Skeleton variant="rectangular" height="400px" />;
  }

  const defaultTab = getDefaultTab();

  // If no tabs available, show access denied
  if (!defaultTab) {
    return <ProjectAccessDenied />;
  }

  return <Navigate to={defaultTab} replace />;
};
